import React from 'react';

const Header = () => {
  return (
    <header className="bg-white shadow-md fixed w-full top-0 z-10">
      <nav className="container mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          <div className="text-xl font-bold">ToopVIP</div>
          <div className="hidden md:flex space-x-6">
            <a href="#home" className="hover:text-blue-600">首页</a>
            <a href="#about" className="hover:text-blue-600">关于我们</a>
            <a href="#services" className="hover:text-blue-600">服务</a>
            <a href="#contact" className="hover:text-blue-600">联系我们</a>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header; 